import { Routes } from '@angular/router';
import { InsightsDashboard } from './components/insights-dashboard/insights-dashboard';
import { PropertyCompletion } from './components/property-completion/property-completion';
import { authGuard } from './auth/auth.guard';
import { MainLayout } from './layout/main-layout/main-layout';

export const routes: Routes = [
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: InsightsDashboard },
      { path: 'property-completion', component: PropertyCompletion },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
